import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import InfoCard from '../../../components/molecule/Cards/InfoCard';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`;

const GridContainer = styled(Grid)`
  flex: 1;
  flex-grow: 1;
`;

const GridColumn = styled(Grid)`
  flex: 1;
  margin: 0 6px;
`;

const ColumnHeader = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
`;

const InfoCardStyled = styled(InfoCard)`
  margin: 4px 0;
`;

class CohortMembers extends Component {
  renderMemberCard = (member, index) => {
    const { removeMember } = this.props;

    return (
      <InfoCardStyled
        key={`members-${index}-${member.id}`}
        header={member.email}
        subtext1={member.user && `Name: ${member.user.name}`}
        onClick={() => removeMember(member)}
      />
    );
  }

  renderUserCard = (user, index) => {
    const { addMember } = this.props;

    return (
      <InfoCardStyled
        cardButtonIcon='arrow_backward'
        cardButtonLeft
        key={`user-${index}-${user.id}`}
        header={user.email}
        subtext1={user.user && `Name: ${user.user.name}`}
        onClick={() => addMember(user)}
      />
    );
  }

  render() {
    const {
      cohort: {
        members,
      },
      users,
    } = this.props;

    return !users ? (
      <LoadingSpinnerPage />
    ) : (
      <Container spacing={8}>
        <GridContainer container spacing={8}>
          <GridColumn item>
            <ColumnHeader>Members</ColumnHeader>
            {members.map((member, index) => {
              return this.renderMemberCard(member, index);
            })}
          </GridColumn>
          <GridColumn item>
            <ColumnHeader>Users</ColumnHeader>
            {users.map((user, index) => {
              return this.renderUserCard(user, index);
            })}
          </GridColumn>
        </GridContainer>
      </Container>
    );
  }
}

CohortMembers.propTypes = {
};

CohortMembers.defaultProps = {
};

function mapStateToProps(state) {
  return {
    companyState: state.companyState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch)
}


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CohortMembers);
